/** @prettier */
import { analyticsManager } from '../../afterBlocks/analytics/analytics';
import { AnalyticsCategories } from '../../afterBlocks/analytics/analyticsCategories';

export default (data) => {
  const { block } = data;
  [...block.querySelectorAll('.ui-site-social-icon')].forEach((button) => {
    button.addEventListener('click', () => {
      const socialName = button.getAttribute('data-xa-name');
      analyticsManager.sendEvent({
        category: AnalyticsCategories.FOOTER,
        event: `sb_footer_social_click-${socialName}`,
        label: socialName,
        page: 'landing_footer_click-social',
      });
    });
  });
};
